import { useSessionFormContext } from "@modules/sessions/hooks/useSessionFormContext"
import { HUText } from "@modules/ui/components/huText"
import { RefObject, useMemo, useRef } from "react"
import Draggable, { DraggableData, DraggableEvent } from "react-draggable"
import { useTheme } from "styled-components"

type RpeSliderProps = {
  isRpe: boolean
}

const SLIDER_WIDTH = 486
const SLIDER_STEP = SLIDER_WIDTH / 10
const SLIDER_COLORS = [
  "#47F255",
  "#9AF247",
  "#B6F247",
  "#DDF247",
  "#F2E747",
  "#F2D047",
  "#F2AB47",
  "#F27A47",
  "#F24747",
  "#E91010",
]

export const RpeSlider: React.FC<RpeSliderProps> = ({ isRpe }) => {
  const theme = useTheme()
  const { formik, updatedBlockIndex } = useSessionFormContext()
  const childRef = useRef<HTMLDivElement>(null)

  const fieldProps = formik.getFieldProps(`blocks[${updatedBlockIndex}].content.rpe`)

  const positionRound = useMemo(() => {
    if (fieldProps.value !== 0 && fieldProps.value !== null) {
      return (fieldProps.value - 1) * SLIDER_STEP - 16
    } else return -16
  }, [fieldProps.value])

  const handleDrag = (_: DraggableEvent, data: DraggableData) => {
    if (data.x !== undefined) {
      formik.setFieldValue(`blocks[${updatedBlockIndex}].content.rpe`, Math.round((data.x + 16) / SLIDER_STEP + 1))
    }
  }

  return (
    <div className="relative pt-4" style={{ width: SLIDER_WIDTH }}>
      <Draggable
        grid={[SLIDER_STEP, 0]}
        axis="x"
        position={{ x: positionRound, y: 20 }}
        onDrag={handleDrag}
        bounds={{ left: -16, right: SLIDER_WIDTH - 16 - SLIDER_STEP }}
        disabled={!isRpe}
        nodeRef={childRef as RefObject<HTMLElement>}
      >
        <div className="relative z-1" style={{ marginLeft: SLIDER_STEP / 2, width: SLIDER_STEP }} ref={childRef}>
          <div
            className="flex align-items-center justify-content-center rounded-full"
            style={{
              backgroundColor: isRpe ? theme.neutralColor900 : theme.neutralColor700,
              height: 34,
              width: 34,
              cursor: "grab",
            }}
          >
            <HUText type="label" fontStyle="BM" color={theme.neutralColor100} className="cursor-grab">
              {fieldProps.value ?? 1}
            </HUText>
          </div>

          <div
            className={`absolute border-1 ${isRpe ? "border-900" : "border-700"}`}
            style={{ width: 0, height: 30, left: 16 }}
          />
        </div>
      </Draggable>

      <div className="flex flex-column justify-content-center mt-4">
        <div className="flex flex-row w-full align-items-center justify-content-around rounded-big-radius overflow-hidden">
          {Array.from({ length: 10 }).map((_, index) => (
            <div
              key={index}
              onClick={() => isRpe && formik.setFieldValue(`blocks[${updatedBlockIndex}].content.rpe`, index + 1)}
              style={{
                backgroundColor: isRpe ? SLIDER_COLORS[index] : theme.neutralColor400,
                height: 20,
                width: SLIDER_STEP,
              }}
              className="relative overflow-visible cursor-pointer"
            />
          ))}
        </div>

        <div className="flex justify-content-between mt-2 text-center">
          <HUText type="label" fontStyle="BM" color={theme.neutralColor900} style={{ width: SLIDER_STEP }}>
            1
          </HUText>
          <HUText type="label" fontStyle="BM" color={theme.neutralColor900} style={{ width: SLIDER_STEP }}>
            10
          </HUText>
        </div>
      </div>
    </div>
  )
}
